import {useState} from "react";
import {Button, Stack, Table} from "react-bootstrap";
import {ContactTypeFilterUserData} from "../../../../types/ContactTypeFilter";
import ContactFilterForm from "./ContactFilterForm";
import ContactFilterTableRow from "./ContactFilterTableRow";

export type NodeEditContactFiltersProps = {
	filters: Array<ContactTypeFilterUserData>;
	onChange: (filters: Array<ContactTypeFilterUserData>) => void;
}

export default function NodeEditContactFilters({filters, onChange}: NodeEditContactFiltersProps) {
	const [editFilter, setEditFilter] = useState<ContactTypeFilterUserData | null>(null);
	const [selectedFilter, setSelectedFilter] = useState<ContactTypeFilterUserData | null>(null);

	return (
		<div>
			<Stack direction="horizontal" gap={2}>
				<Button
					variant="success"
					onClick={
						() => {
							setEditFilter(
								{
									contactTypeId: NaN,
									targetGroups: []
								}
							);
						}
					}
				>přidat</Button>
				<Button
					variant="primary"
					disabled={selectedFilter === null}
					onClick={() => setEditFilter(selectedFilter)}
				>upravit</Button>
				<Button
					variant="danger"
					disabled={selectedFilter === null}
					onClick={
						() => {
							onChange(
								filters.filter((l) => l !== selectedFilter)
							);
						}
					}
				>smazat</Button>
			</Stack>
			<Table>
				<thead>
				<tr>
					<th>Zdroj</th>
					<th>Druh pomoci</th>
					<th>Cílové skupiny</th>
				</tr>
				</thead>
				<tbody>
				{
					filters.map(
						(filter, index) => <ContactFilterTableRow
							key={index}
							filter={filter}
							active={filter === selectedFilter}
							onClick={setSelectedFilter}
							onDoubleClick={setEditFilter}
						/>
					)
				}
				</tbody>
			</Table>
			{
				editFilter !== null && <ContactFilterForm
					contactFilter={editFilter}
					onClosed={() => setEditFilter(null)}
					onSaved={
						(filter) => {
							if (filters.includes(editFilter)) {
								onChange(filters.map((f) => f === editFilter ? filter : f));
							} else {
								onChange([...filters, filter]);
							}
							setEditFilter(null);
						}
					}
				/>
			}
		</div>
	);
}
